__turbopack_context__.v({
  "exitButton": "style-module-scss-module__U_plxq__exitButton",
  "logo": "style-module-scss-module__U_plxq__logo",
  "logoLink": "style-module-scss-module__U_plxq__logoLink",
  "shell": "style-module-scss-module__U_plxq__shell",
  "topBar": "style-module-scss-module__U_plxq__topBar",
});
